import http from '@/services/http'

export default {
  loadAccount () {
    return http.get('/players/account')
  },
  removePaymentMethod ({ token }) {
    return http.post('/players/remove-payment-method', { token })
  }
}
